import {
  HamburgerSvg,
  LanguageSvg,
  NotificationSvg,
} from 'icons'
import { Link, useHistory } from 'react-router-dom'
import React, { useState } from 'react'

import Avatar from 'components/Avatar/Avatar'
import Dropdown from '../Dropdown/Dropdown'
import IconButton from '../IconButton/IconButton'
import { classNames } from 'helpers'
import { useLocation } from 'react-router'

type LanguageType = {
  name: string
  onClick: () => void
}

interface HeaderProps {
  className?: string
  name: string
  image: any
  action: string
  date: string
  languages: LanguageType[]
  logo: any
  setSidebarOpen: any
}

const Header: React.FC<HeaderProps> = ({
  className,
  name,
  image,
  action,
  date,
  children,
  languages,
  logo,
  setSidebarOpen,
  ...args
}) => {
  const history = useHistory()
  const Logo = logo
  const [language, setLanguage] = useState({
    name: 'Spanish',
  })
  const location = useLocation()

  return (
    <div className={`mx-auto ${className}`} {...args}>
      <div className="flex items-center justify-end pt-6 pb-4 md:pt-2 md:pb-2 lg:justify-start">
        <div
          className="flex items-center h-16 lg:space-x-16"
          style={{ width: 1440 }}
        >
          <div
            className={classNames(
              'items-center justify-center hidden w-24 py-8 md:flex',
              location?.pathname?.includes('settings')
                ? ''
                : 'bg-blue-1'
            )}
          >
            <Link to="/">
              <Logo className="h-5 w-9" />
            </Link>
          </div>
          <div className="justify-start hidden lg:flex lg:w-0 lg:flex-1">
            <div className="hidden lg:block">
              <Avatar
                action={action}
                image={image}
                name={name}
                href="/profile"
              />
            </div>
          </div>
          <div
            className="flex items-center justify-end ml-auto space-x-5"
            style={{ width: 530, height: 50 }}
          >
            <p className="flex-1 hidden text-lg font-medium leading-none tracking-wider md:block">
              {date}
            </p>
            <div className="flex items-center justify-end w-40 h-10 pl-1 space-x-2">
              <IconButton icon={LanguageSvg} />
              <Dropdown
                selectedItem={language}
                setSelectedItem={setLanguage}
                data={languages}
                search
              />
              <IconButton icon={NotificationSvg} />
              <IconButton
                icon={HamburgerSvg}
                onClick={() => {
                  setSidebarOpen((prev: boolean) => !prev)
                  history.push('/settings')
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Header.defaultProps = {
  languages: [],
}

export default Header
